// REFACTORED VS OF  src/components/manage/website/entities/RegistryV2
// TODO: remove REGISTRYV2 AND REGISTRYPREVIEW after prod release

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';

import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Toggle from 'react-toggle';
import { ButtonV2 } from '@zola/zola-ui';

// Actions
import { showModal } from 'actions/ModalActions';
import { editRegistry } from 'actions/website/entities/RegistryActions';
import { moveEntity, resetEntities } from 'actions/website/EntityActions';
import { togglePage } from 'actions/website/PageActions';
import { fetchRegistry, updateRegistryPublish } from 'actions/RegistryActions';

// Content
import EDIT_PAGES_CONTENT from 'constants/EditPagesContent/EditPagesContent';

// Components
import DragHandle from '../../../../../common/ui/DragHandle';
import EditPageForm from '../../EditPageCommon/EditPageForm';
import EditPageHeader from '../../EditPageCommon/EditPageHeader';
import EditPageSortableList, { EntityName } from '../../EditPageCommon/EditPageSortableList';

import AddARegistryLink from '../components/AddARegistryLink';
import BuildZolaRegistryCTA from '../components/BuildZolaRegistryCTA';

const Registry = SortableElement(({ registry, onEdit, onDelete }) => {
  const noPropagate = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  return (
    <li
      className="sortable-registry sortable-item editable-entity"
      onClick={() => onEdit(registry)}
    >
      <div className="col-sm-1">
        <DragHandle tooltip="Drag to reorder" />
      </div>
      <div className="col-sm-8">
        <span className="title-v2">{registry.name}</span>
      </div>
      <div className="col-sm-3 entity-actions" onClick={noPropagate}>
        <button
          onClick={() => onEdit(registry)}
          title="Edit Registry"
          className="btn btn-icon with-tooltip no-tooltip-on-mobile"
          data-tooltip="Edit"
        >
          <i className="glyphicon glyphicon-pencil" />
        </button>
        <button
          onClick={() => onDelete(registry)}
          title="Delete Registry"
          className="btn btn-icon with-tooltip no-tooltip-on-mobile"
          data-tooltip="Delete"
        >
          <i className="glyphicon glyphicon-trash" />
        </button>
      </div>
    </li>
  );
});

const RegistryDetails = entity => {
  const entityName = entity && entity.name;
  return <EntityName name={entityName} />;
};

Registry.propTypes = {
  registry: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number,
};

class Registries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registryPublished: false,
    };
    this.onToggleRegistryPublish = this.onToggleRegistryPublish.bind(this);
  }

  componentDidMount() {
    const { getRegistry, hasZolaRegistry } = this.props;
    if (hasZolaRegistry) {
      getRegistry().then(() => this.setState({ registryPublished: this.props.registry.is_public }));
    }
  }

  componentWillReceiveProps(nextProps) {
    const { registry } = this.props;
    if (registry.is_public !== nextProps.registry.is_public) {
      this.setState({
        registryPublished: nextProps.registry.is_public,
      });
    }
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  onToggleRegistryPublish(e) {
    const { onToggleRegistryPublish, setShippingAddress, registry } = this.props;
    const newValue = e.target.checked;
    if (!registry.has_shipping_address) {
      setShippingAddress();
    } else {
      onToggleRegistryPublish(newValue);
    }
  }

  render() {
    const {
      registries,
      orderedIds,
      onEdit,
      onDelete,
      page,
      hasZolaRegistry,
      slug,
      themeKey,
      onPageToggle,
    } = this.props;
    const { registryPublished } = this.state;
    const pageType = page ? page.type : undefined;
    const pageContent = pageType ? EDIT_PAGES_CONTENT[pageType] : {};
    const pageDek = hasZolaRegistry
      ? pageContent.dek.hasZolaRegistry
      : pageContent.dek.noZolaRegistry;
    const hasOtherRegistries = orderedIds.length > 0;

    return (
      <div
        className={`edit-page edit-registry ${
          hasZolaRegistry ? 'registry-activated' : 'registry-not-activated'
        }`}
      >
        {themeKey && (
          <EditPageHeader
            page={page}
            pageDek={pageDek}
            themeKey={themeKey}
            onPageToggle={onPageToggle}
          />
        )}
        <EditPageForm page={page} />
        {hasZolaRegistry && (
          <section className="manage-zola-registry">
            <h4 className="registry__title">Zola Registry</h4>
            <div className="toggle-registry-visible">
              <div
                className="with-tooltip no-tooltip-on-mobile"
                data-tooltip='Ready to show off your registry? Switch the toggle to "Yes" and anyone will be able to see it. Not ready yet? Keep the toggle on "No."'
              >
                <span className="toggle__text">Visible to Guests?</span>
                <Toggle
                  checked={registryPublished}
                  onChange={this.onToggleRegistryPublish}
                  className="toggle__button toggle-small toggle-red"
                  icons={{
                    checked: <span className="toggle-label checked">Yes</span>,
                    unchecked: <span className="toggle-label unchecked">No</span>,
                  }}
                />
              </div>
            </div>
            <ButtonV2
              component="a"
              variant="secondary"
              role="link"
              href={`/registry/${slug}/edit`}
              className="manage-zola-registry-btn"
            >
              Manage Your Registry
            </ButtonV2>
          </section>
        )}
        {!hasZolaRegistry && (
          <BuildZolaRegistryCTA
            className="registry-options margin-top"
            hasExternalRegistry={hasOtherRegistries}
          />
        )}
        <section className="add-another-registry">
          <p className="add-another-registry__info">
            <b>Have a registry at another store?</b> Link to it on this page.
          </p>
          <AddARegistryLink className="add-another-registry__btn" />
        </section>
        {!_isEmpty(registries) && (
          <EditPageSortableList
            pageType={pageType}
            orderedIds={orderedIds}
            entities={registries}
            onEdit={onEdit}
            onDelete={onDelete}
            entityDetail={RegistryDetails}
            useDragHandle
            lockAxis="y"
          />
        )}
      </div>
    );
  }
}

Registries.propTypes = {
  registries: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getRegistry: PropTypes.func.isRequired,
  onToggleRegistryPublish: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  hasZolaRegistry: PropTypes.bool,
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
  slug: PropTypes.string,
  registry: PropTypes.shape({
    is_public: PropTypes.bool,
  }),
  setShippingAddress: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  dashboard: state.dashboard,
  registry: state.registry,
  registries: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.REGISTRY],
  hasZolaRegistry: state.user.userContext.registry_ids.length > 0,
  themeKey: state.wedding.theme.key,
  slug: state.wedding.wedding.slug,
});

const mapDispatchToProps = dispatch => ({
  onSortEnd: ({ oldIndex, newIndex }) => dispatch(moveEntity(oldIndex, newIndex)),
  onEdit: registry => {
    dispatch(editRegistry(registry));
    dispatch(showModal('REGISTRY', { isUpdate: true }, { size: 'md' }));
  },
  onDelete: entity => dispatch(showModal('DELETE_ENTITY', { entity })),
  unloadEntities: () => dispatch(resetEntities()),
  getRegistry: () => dispatch(fetchRegistry()),
  onPageToggle: pageId => dispatch(togglePage(pageId)),
  onToggleRegistryPublish: value => {
    if (value)
      return dispatch(updateRegistryPublish(value)).then(() =>
        dispatch(showModal('PUBLISH_REGISTRY', {}, { size: 'md' }))
      );
    return dispatch(updateRegistryPublish(value));
  },
  setShippingAddress: () => dispatch(showModal('SET_SHIPPING_ADDRESS', {}, { size: 'md' })),
});

const SortableRegistries = SortableContainer(Registries);

const RegistriesContainer = connect(mapStateToProps, mapDispatchToProps)(SortableRegistries);

export default RegistriesContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/Registry/RegistryV2.jsx